export const STANDARD = 'standard'
export const NON_STANDARD = 'non_standard'

export const ALL_LEASE_HANDOVER_TYPES = [STANDARD, NON_STANDARD] as const

export type LeaseHandoverType = (typeof ALL_LEASE_HANDOVER_TYPES)[number]
